<template>
  <div v-if="stock_detail.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <!-- 明细 -->
      <v-tooltip
        top
        v-if="showView && $permission.permissionAllow('StockDetails', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="'/#/stock-details/' + stock_detail.id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("Opt.details")]) }}</span>
      </v-tooltip>
      <!-- 编辑 -->
      <!-- <v-tooltip
        top
        v-if="showEdit && $permission.permissionAllow('StockDetails', 'edit')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('edit')
                  : $router.push(
                      '/stock-orders-out/' + stock_outs.id + '/edit'
                    );
              })
            "
          >
            <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
            {{ $t("StockOrderOUT.actions.edit") }}
          </v-btn>
        </template>
        <span>{{ $t("StockOrderOUT.actions.editStockOUT") }}</span>
      </v-tooltip> -->
      <!-- 冻结 -->
      <v-tooltip
        top
        v-if="
          showProhibit &&
          stock_detail.actions &&
          stock_detail.actions.prohibit &&
          $permission.permissionAllow('StockDetails', 'prohibit')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="cancelProhibit = true"
          >
            <v-icon x-small class="pe-1">fa-stamp</v-icon>
            {{ $t("stockDetail.actions.prohibit") }}
          </v-btn>
        </template>
        <span>{{ $t("stockDetail.actions.prohibit") }}</span>
      </v-tooltip>
      <!-- 解冻 -->
      <v-tooltip
        top
        v-if="
          showUnProhibit &&
          stock_detail.actions &&
          stock_detail.actions.un_prohibit &&
          $permission.permissionAllow('StockDetails', 'unProhibit')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="cancelUnProhibit = true"
          >
            <v-icon x-small class="pe-1">fa-stamp</v-icon>
            {{ $t("stockDetail.actions.un_prohibit") }}
          </v-btn>
        </template>
        <span>{{ $t("stockDetail.actions.un_prohibit") }}</span>
      </v-tooltip>
      <!-- 报损 -->
      <v-tooltip
        top
        v-if="showLoss &&
        stock_detail.actions &&
        stock_detail.actions.loss &&
        $permission.permissionAllow('StockDetails', 'loss')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="cancelLoss = true"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("stockDetail.actions.loss") }}
          </v-btn>
        </template>
        <span>{{ $t("stockDetail.actions.loss") }}</span>
      </v-tooltip>
      <!-- 明细打印 -->
      <v-tooltip
        top
        v-if="showPrint && $permission.permissionAllow('StockDetails', 'stockDetailsPrint')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="doPrint('stockDetailsPrint')"
          >
            <v-icon x-small class="pe-1">fa-print</v-icon>
            {{ $t("stockDetail.actions.detail_print") }}
          </v-btn>
        </template>
        <span>{{ $t("stockDetail.actions.detail_print") }}</span>
      </v-tooltip>
      <!-- 明细导出 -->
      <v-tooltip
        top
        v-if="showExport && $permission.permissionAllow('StockDetails', 'stockDetailsExport')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click="stockDetailExport()"
          >
            <v-icon x-small class="pe-1">fa-file-export</v-icon>
            {{ $t("stockDetail.actions.detail_export") }}
          </v-btn>
        </template>
        <span>{{ $t("stockDetail.actions.detail_export") }}</span>
      </v-tooltip>
    </v-sheet>
    <DialogLoss
      v-model="cancelLoss"
      cancel-mode
      :label="$t('StockDetails.ObjectName')"
      :code="stock_detail.stock_batch_code"
      @confirm="
        doAction('loss');
        cancelLoss = false;
      "
    />
    <DialogProhibit
      v-model="cancelProhibit"
      cancel-mode
      :label="$t('StockDetails.ObjectName')"
      :code="stock_detail.stock_batch_code"
      @confirm="
        doAction('prohibit');
        cancelProhibit = false;
      "
    />
    <!-- UnProhibit -->
    <DialogUnProhibit
      v-model="cancelUnProhibit"
      cancel-mode
      :label="$t('StockDetails.ObjectName')"
      :code="stock_detail.stock_batch_code"
      @confirm="
        doAction('unProhibit');
        cancelUnProhibit = false;
      "
    />
  </div>
</template>

<script>
import StockDetails from "@/api/stock_details";
import DialogLoss from "@/components/plugins/DialogLoss";
import DialogProhibit from "@/components/plugins/DialogProhibit";
import DialogUnProhibit from "@/components/plugins/DialogUnProhibit";

export default {
  name: "StockDetailsActions",

  props: {
    stock_detail: Object,
    // detailMode: Boolean,
    showView: Boolean,
    // showEdit: Boolean,
    showProhibit: Boolean,
    showUnProhibit: Boolean,
    showLoss: Boolean,
    showPrint: Boolean,
    showExport: Boolean,
  },
  components: {
    DialogLoss,
    DialogProhibit,
    DialogUnProhibit

  },
  data: () => ({
    cancelLoss:false,
    cancelProhibit:false,
    cancelUnProhibit:false
  }),

  methods: {
    actionMethod(mode) {
      if (mode == "prohibit")
        return StockDetails.prohibit(this.stock_detail.id);
      if (mode == "unProhibit")
        return StockDetails.unProhibit(this.stock_detail.id);
      else if (mode == "loss") return StockDetails.loss(this.stock_detail.id);
    },
    // 冻结 / 解冻 / 报损
    doAction(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          this.actionMethod(mode).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$emit("done");
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },
    // 打印
    doPrint(mode) {
      this.$permission.checkAccountExpired().then(
              function () {
                switch (mode) {
                  case "stockDetailsPrint":
                    this.$router.push("/print/stock-details-print/" + this.stock_detail.id);
                    break;
                }
              }.bind(this)
      );
    },
    // 批次明细导出
    stockDetailExport() {
      StockDetails.stockDetailExport(this.stock_detail.id);
    },
  },
};
</script>